import store from "../../store";
import * as customerTypes from '../actionTypes/customerTypes';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { failToast, succToast, serverNotRespond } from "../../helper/ApiToast";
import {
    plansType,
    addCustomerList,
    getCustomerList,
    deleteCustomerList,
    updateCustomerList,
    getCustomerDetails,
    getServerRegion,
    getinstanceTypeCloud,
    getServerConfigurationStatus,
} from "../../services/CustomerServices";
import { getCusDetails } from "../../components/MainContent/Customers/Profile/profileCommon";

function* getPlanType() { //getPlanType Call
    try {
        const planType = yield call(plansType);
        const { data: { status = 0, message = "", data = {} } = {} } = planType || {};
        if (status === 200) {
            const trailValueAdd = data.plansList.map((ele) => {
                if (ele.planName === "Trial") {
                    return {
                        ...ele,
                        planAmount: 999
                    };
                }
                return ele;
            });
            yield all([
                put({ type: "PLAN_TYPES", planType: trailValueAdd }),//Get planType Api call and store
                put({ type: "CUS_PAGE_PLAN_TYPE_API", PlanTypeApiHit: false }), //Loader false
                put({ type: "CUS_PAGE_PLAN_TYPE_API_LOADER", planApiHitLoader: false }), //Loader false
            ]);
        } else {
            serverNotRespond(message); //serverIs Not Respont Call this Toast
            yield all([
                put({ type: "CUS_PAGE_PLAN_TYPE_API", PlanTypeApiHit: false }), //Loader false
                put({ type: "CUS_PAGE_PLAN_TYPE_API_LOADER", planApiHitLoader: false }),
            ]);
        }
    }
    catch (error) {
        serverNotRespond(); //serverIs Not Respont Call this Toast
        yield all([
            put({ type: "CUS_PAGE_PLAN_TYPE_API", PlanTypeApiHit: false }), //Loader false
            put({ type: "CUS_PAGE_PLAN_TYPE_API_LOADER", planApiHitLoader: false }),
        ]);
    }
}

const addcusFailToast = () => {
    store.dispatch({ type: "ADD_CUS_LOADER", addcusLoader: true });//Loader Will Close/open
    store.dispatch({ type: "DO_LOADING", loading: false });//add customer loader fail or pass loder will show
};

function* addCustomer(obj) { // Add New Customer Call
    try {
        const cusData = yield call(addCustomerList, obj);
        const { data: { status = 0, message = "" } = {} } = cusData || {};
        const { data: { data: { userDetails = {} } = {} } = {} } = cusData || {};
        yield put({ type: "SET_API_PROGRESS_ADD_CUSTOMER", addCustomerProgress: 'in-progress' });
        yield put({ type: "SET_ADD_CUSTOMER_MESSAGE", addCustomerMessage: message });
        if (status === 200) {
            yield succToast(message);
            yield put({ type: "SET_API_PROGRESS_ADD_CUSTOMER", addCustomerProgress: (status === 200) ? 'success' : 'in-progress' });
            yield all([
                put({ type: "ADD_CUS_LOADER", addcusLoader: true }),//Loader Will Close/open
                put({ type: "CUS_PAGE_API_LOAD", apiHit: true }), //referesh customer list
                put({ type: "GET_USERID", userId: userDetails.userId }), //referesh customer list
                put({ type: "CUSTOMER_PAGE_OPEN_CLOSE", cusPageOpen: true }), //customer added succeesfully opoup close
                put({ type: "DO_LOADING", loading: false }),//add customer loader fail or pass loder will show
            ]);
            yield put({ type: "INITAIL_RENDER_DATA", dataRenderCusPage: true });

        } else if (status >= 201 && status <= 400) {
            failToast(message);
             addcusFailToast();
        }  else if(message === "Customer created successfully" || message === "Changes saved successfully"){
            updateCusList(obj)
         }
        else {
            serverNotRespond(message); //serverIs Not Respont Call this Toast
             addcusFailToast();
        }
    }
    catch (error) {
        serverNotRespond(); //serverIs Not Respont Call this Toast
         addcusFailToast();
    }
}

const getCusErrorToast = () => {
    serverNotRespond(); //serverIs Not Respont Call this Toast
    store.dispatch({ type: "DO_LOADING_CUSTOMER_PAGE", cusPageloading: false });//when reRender loder On
    store.dispatch({ type: "CUS_PAGE_API_LOAD", apiHit: false });//GetCustomer List Loader
    store.dispatch({ type: "CUS_PAGE_SEARCH_LOAD", searchLoader: true });
    store.dispatch({ type: "DO_LOADING", loading: false });//loader off
};

function* getCusList(obj = {}) { //Get full List History
    try {
        const getCusData = yield call(getCustomerList, obj);
        const { data } = getCusData || {};
        const { status = 0 } = data || {};
        if (status >= 200 && status <= 300) {
            yield all([
                put({ type: "DO_LOADING_CUSTOMER_PAGE", cusPageloading: false }),//when reRender loder On
                put({ type: "CUSTOMER_LIST", cusList: data }),//GetCustomer List and store
                put({ type: "CUS_PAGE_API_LOAD", apiHit: false }),//GetCustomer List Loader
                put({ type: "CUS_PAGE_SEARCH_LOAD", searchLoader: true }),
                put({ type: "DO_LOADING", loading: false })//loader off
            ]);
            yield put({ type: "RESET_CUSTOMER_LIST_FILTER", resetCustomersListFilter: false });

        } else {
            getCusErrorToast();
        }
    }
    catch (error) {
        getCusErrorToast();
    }
}

function* deleteCustomer(array = {}) {
    yield put({ type: "DO_LOADING", loading: true });
    try {
        const delCusData = yield call(deleteCustomerList, array.customerIds);
        const { data: { status = 0, message = "" } = {} } = delCusData || {};
        if (status === 200) {
            succToast(message);
            yield all([
                put({ type: "INITAIL_RENDER_DATA", dataRenderCusPage: true }),
                put({ type: "DO_LOADING", loading: false }),
                put({ type: "CUS_PAGE_API_LOAD", apiHit: true }),//when reRender loder On
                put({ type: "DO_DELETE_ACTION_LOAD", cusDeleteLoad: false }),
            ]);
        } else {
            serverNotRespond(message);
        }
    }
    catch (error) {
        serverNotRespond();
    }
    yield put({ type: "DO_LOADING", loading: false });

}

function* updateCusList(obj) { //Edit or Update Call
    try {
        const updateCusData = yield call(updateCustomerList, obj);
        const { data: { status = 0, message = "" } = {} } = updateCusData || {};
        yield put({ type: "SET_API_PROGRESS_ADD_CUSTOMER", addCustomerProgress: 'in-progress' });
        yield put({ type: "SET_ADD_CUSTOMER_MESSAGE", addCustomerMessage: message });
        if (status === 200) {
            yield put({ type: "SET_API_PROGRESS_ADD_CUSTOMER", addCustomerProgress: (status === 200) ? 'success' : 'in-progress' });
            succToast(message);
            yield all([
                put({ type: "CUS_PAGE_API_LOAD", apiHit: false }), //referesh customer list
                put({ type: "ADD_CUS_LOADER", addcusLoader: true }),//Loader Will Close/open
                put({ type: "DO_LOADING", loading: false }),
            ]);
            getCusDetails(obj?.data?.userInput?.userId || 0);

        } else if (status >= 201 && status <= 400) {
            failToast(message);
            yield all([
                 put({ type: "ADD_CUS_LOADER", addcusLoader: true }),//Loader Will Close/open
            ]);
        } else {
            serverNotRespond(message); //serverIs Not Respont Call this Toast
            yield all([
                 put({ type: "ADD_CUS_LOADER", addcusLoader: true }),//Loader Will Close/open
            ]);
        }
    }
    catch (error) {
        yield all([
             put({ type: "ADD_CUS_LOADER", addcusLoader: false }),//Loader Will Close/open
        ]);
    }
}

function* getCustomerDetailsSaga(obj) { //Singele Profile view
    try {
        const custDetails = yield call(getCustomerDetails, obj);
        const { data: { status = 0, data: { userDetails = {} } = {} } = {} } = custDetails || {};
        if (status === 200) {
            yield all([
                put({ type: "CUSTOMER_DETAILS", customerDtls: userDetails }),//Result Store
                put({ type: "DO_LOADING_EDIT", loading: false }),//Loader open/close
            ]);
        } else {
            yield all([
                put({ type: "CUSTOMER_DETAILS", customerDtls: {} }),//Result Store
                put({ type: "DO_LOADING_EDIT", loading: false }),//Loader open/close
            ]);
        }
    }
    catch (error) {
        yield all([
            put({ type: "CUSTOMER_DETAILS", customerDtls: {} }),//Result Store
            put({ type: "DO_LOADING_EDIT", loading: false }),//Loader open/close
        ]);
    }
}

function* exportCustomersList(obj = {}) {
    const response = yield call(getCustomerList, obj);
    try {
        const { data: { status = 0, message = "", data = {} } } = response || {};

        if (status === 200) {
            yield put({ type: "CUSTOMERS_LIST_EXPORT_DATA", exportData: data?.users || [] });
            yield put({ type: "ENABLE_CUSTOMERS_EXPORT_OPTION", enableExport: true });
        } else {
            failToast(message);
        }
    }
    catch (error) {
        serverNotRespond();
    }
    yield put({ type: "DO_LOADING", loading: false });
}
function* getServerRegionSaga(obj) { //Singele Profile view
    try {
        const response = yield call(getServerRegion, obj);
        const { data = {} } = response || {};
        const { status = 0 } = data || {};
        if (status === 200) {
            yield all([
                put({ type: "GET_SERVER_REGION", serverRegion: data }),//Result Store
            ]);
        } else {
            yield all([
                put({ type: "GET_SERVER_REGION", serverRegion: {} }),//Result Store
            ]);
        }
    }
    catch (error) {
        yield all([
            put({ type: "GET_SERVER_REGION", serverRegion: {} }),//Result Store
        ]);
    }
}
function* getInstanceCloudSaga(obj) { //Singele Profile view
    try {
        const response = yield call(getinstanceTypeCloud, obj);
        const { data = {} } = response || {};
        const { status = 0 } = data || {};
        if (status === 200) {
            yield all([
                put({ type: "GET_INSTANCE_TYPE_CLOUD", instanceTypeCloud: data }),//Result Store
            ]);
        } else {
            yield all([
                put({ type: "GET_INSTANCE_TYPE_CLOUD", instanceTypeCloud: {} }),//Result Store
            ]);
        }
    }
    catch (error) {
        yield all([
            put({ type: "GET_INSTANCE_TYPE_CLOUD", instanceTypeCloud: {} }),//Result Store
        ]);
    }
}
function* getServerStausSaga(obj) { //Singele Profile view
    try {
        const response = yield call(getServerConfigurationStatus, obj);
        const { data = {} } = response || {};
        const { status = 0 } = data || {};
        yield put({ type: "SET_API_PROGRESS_AUTOMATION_SCRIPT", automationScriptProgress: 'in-progress' });
        if (status === 200) {
            let statusText = "in-progress";
            switch (data?.data?.serverStatusCode) {
              case 0:
                statusText = "NOT_INITIATED";
                break;
              case 1:
                statusText = "SUCCESS";
                break;
              case 2:
                statusText = "IN_PROGRESS";
                break;
              case 3:
                statusText = "FAIL";
                break;
              default:
                statusText = "in-progress";
            }
            yield put({ type: "SET_API_PROGRESS_AUTOMATION_SCRIPT", automationScriptProgress: statusText });
            yield all([
                put({ type: "GET_SERVER_CONFIGURATION_DATA_STATUS", serverStatus: data.data }),//Result Store
            ]);
        } else {
            yield all([
                put({ type: "GET_SERVER_CONFIGURATION_DATA_STATUS", serverStatus: {} }),//Result Store
            ]);
        }
    }
    catch (error) {
        yield all([
            put({ type: "GET_SERVER_CONFIGURATION_DATA_STATUS", serverStatus: {} }),//Result Store
        ]);
    }
}
export default function* customerSaga() {
    // yield takeLatest(customerTypes.DATA_FETCH, getPlanType);
    yield takeLatest(customerTypes.CUSTOMER_ADD, addCustomer);
    yield takeLatest(customerTypes.CUSTOMER_GET_LIST, getCusList);
    yield takeLatest(customerTypes.CUSTOMER_UPDATE, updateCusList);
    yield takeLatest(customerTypes.CUSTOMER_DELETE, deleteCustomer);
    yield takeLatest(customerTypes.GET_CUST_DETAILS, getCustomerDetailsSaga);
    yield takeLatest(customerTypes.EXPORT_CUSTOMER_LIST, exportCustomersList);
    yield takeLatest(customerTypes.GET_SERVER_REGION_LIST, getServerRegionSaga);
    yield takeLatest(customerTypes.GET_INSTANCE_TYPE_CLOUD_LIST, getInstanceCloudSaga);
    yield takeLatest(customerTypes.GET_SERVER_CONFIGURATION_STATUS, getServerStausSaga);
}
